import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import OrderSummary from './OrderSummary';
import EmptyCart from './EmptyCart';

const OrderSummaryContainer = ({
  productsInCart,
  combos,
  isForPreview,
  isFromReviewPage,
  favouritesList,
}) => {
  // useEffect(() => {
  //   setIsForPreview(false);
  // }, []);
  if (productsInCart.length || combos.length) {
    return (
      <OrderSummary
        productsInCart={productsInCart}
        combos={combos}
        isForPreview={isForPreview}
        cartIsEmpty={false}
        isFromReviewPage={isFromReviewPage}
        favouritesList={favouritesList}
      />
    );
  } else {
    return <EmptyCart isForPreview={isForPreview} />;
  }
};

const mapStateToProps = (state) => ({
  productsInCart: state.cartReducer.products,
  combos: state.cartReducer.combos,
  isForPreview: state.cartReducer.isForPreview,
  favouritesList: state.favouritesReducer.favouritesList,
});

export default connect(
  mapStateToProps
  // {setIsForPreview}
)(OrderSummaryContainer);
